const PrivacyPolicy = () => {
  return (
    <main
      className="max-w-4xl mx-auto p-6 text-gray-800 leading-relaxed"
      aria-label="Privacy Policy"
    >
      <article className="space-y-6">
        <h1 className="text-3xl font-bold">Privacy Policy for Bharat App</h1>
        <p>
          This Privacy Policy explains how <strong>Learn Now Academy</strong>
          ("we," "us," or "our") handles information from and about you when you
          use our social media application, <strong>Bharat App</strong>.
        </p>

        <hr />

        <section>
          <h2>1. Eligibility & Age Requirement</h2>
          <p>
            Our app is intended for individuals who are at least{" "}
            <strong>13 years old</strong>. By creating an account or using our
            services, you confirm that you are 13 years of age or older. We do
            not knowingly collect personal information from children under 13.
            If we learn that we have collected personal data from a child under
            13, we will take immediate steps to delete it.
          </p>
        </section>

        <hr />

        <section>
          <h2>2. Information We Collect</h2>
          <p>
            We collect information to provide and improve our social media
            services, including:
          </p>
          <ul>
            <li>
              <strong>Account Information:</strong> Your name, username, email
              address, phone number, profile picture, bio, and other details you
              choose to share when creating your profile.
            </li>
            <li>
              <strong>User-Generated Content:</strong> Posts, comments,
              messages, photos, videos, and any other content you create or
              share within the app.
            </li>
            <li>
              <strong>Contacts and Connections:</strong> If you grant access, we
              may use your contacts to help you find friends on the app. This
              data is processed securely and not stored permanently.
            </li>
            <li>
              <strong>Usage and Device Data:</strong> We automatically collect
              information about your interactions with the app, such as activity
              logs, likes, shares, and device details (IP address, OS, app
              version).
            </li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>
              <strong>To Provide the Service:</strong> Enable you to create an
              account, connect with friends, and share content.
            </li>
            <li>
              <strong>To Personalize Your Experience:</strong> Suggest
              connections, content, and features relevant to your interests.
            </li>
            <li>
              <strong>To Improve Safety:</strong> Detect and prevent misuse,
              spam, or harmful content.
            </li>
            <li>
              <strong>To Communicate with You:</strong> Send notifications,
              updates, and respond to support requests.
            </li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>4. Third-Party Services</h2>
          <p>
            We may use third-party services (e.g., analytics, crash reporting,
            cloud hosting) to operate and improve our app. These third parties
            may collect limited information as needed to provide their services.
            We do not sell your personal information.
          </p>
        </section>

        <hr />

        <section>
          <h2>5. Your Rights and Choices</h2>
          <ul>
            <li>
              <strong>Account Control:</strong> You can edit or delete your
              account at any time.
            </li>
            <li>
              <strong>Data Access:</strong> You may request a copy of the
              personal data we hold about you.
            </li>
            <li>
              <strong>Parental Concerns:</strong> Parents or guardians who
              believe their child under 13 has created an account may contact us
              for removal.
            </li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>6. Data Security</h2>
          <p>
            We take reasonable measures to protect your personal data. However,
            no system is 100% secure, and we cannot guarantee absolute
            protection.
          </p>
        </section>

        <hr />

        <section>
          <h2>7. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Significant
            changes will be notified within the app or via other communication
            methods. Continued use of the app after updates means you accept the
            revised policy.
          </p>
        </section>

        <hr />

        <section>
          <h2>8. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact us at:</p>
          <ul>
            <li>
              <strong>Email:</strong> praispranav@gmail.com
            </li>
            <li>
              <strong>Website:</strong>{" "}
              https://www.learnnowacademy.co.in/pages/home
            </li>
          </ul>
        </section>

        <p className="last-updated">
          <strong>Last updated:</strong>{" "}
          <time dateTime="2025-08-26">26 Aug 2025</time>
        </p>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
